import React, { useEffect, useState } from "react";
import QRCode from "qrcode.react";
import toastError from "../../errors/toastError";

import { Dialog, DialogContent, Paper, Typography, List, ListItem, ListItemText, Divider } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import { socketConnection } from "../../services/socket";

const QrcodeModal = ({ open, onClose, whatsAppId }) => {
  const [qrCode, setQrCode] = useState("");

  useEffect(() => {
    const fetchSession = async () => {
      if (!whatsAppId) return;

      try {
        const { data } = await api.get(`/whatsapp/${whatsAppId}`);
        setQrCode(data.qrcode);
      } catch (err) {
        toastError(err);
      }
    };
    fetchSession();
  }, [whatsAppId]);

  useEffect(() => {
    if (!whatsAppId) return;
    const companyId = localStorage.getItem("companyId");
    const socket = socketConnection({ companyId });

    socket.on(`company-${companyId}-whatsappSession`, (data) => {
      if (data.action === "update" && data.session.id === whatsAppId) {
        setQrCode(data.session.qrcode);
      }

      if (data.action === "update" && data.session.qrcode === "") {
        onClose();
      }
    });

    return () => {
      socket.disconnect();
    };
  }, [whatsAppId, onClose]);

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" scroll="paper">
      <DialogContent>
        <Paper elevation={0} style={{ padding: 24, textAlign: "center" }}>
          <Typography variant="h6" color="primary" gutterBottom>
            {i18n.t("qrCode.message")}
          </Typography>

          <Typography variant="body1" color="textSecondary" style={{ marginBottom: 20 }}>
            Para começar a usar o <strong>Message Express</strong>, siga os passos abaixo:
          </Typography>

          <List style={{ marginBottom: 24 }}>
            <ListItem>
              <ListItemText
                primary="1. Abra o aplicativo do WhatsApp no seu celular."
                secondary="Certifique-se de estar conectado à internet."
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText
                primary="2. Toque em ⋮ (mais opções) ou vá em Configurações e selecione 'Aparelhos Conectados'."
                secondary="Pode estar também como 'Dispositivos vinculados', dependendo da versão."
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemText
                primary="3. Aponte a câmera do seu celular para o QR Code abaixo."
                secondary="Mantenha a tela bem iluminada para uma leitura mais rápida."
              />
            </ListItem>
          </List>

          {qrCode ? (
            <div style={{ display: "flex", justifyContent: "center", padding: "16px 0" }}>
              <QRCode value={qrCode} size={256} level="H" />
            </div>
          ) : (
            <Typography variant="body2" color="textSecondary" style={{ marginTop: 20 }}>
              Aguardando geração do QR Code...
            </Typography>
          )}
        </Paper>
      </DialogContent>
    </Dialog>
  );
};

export default React.memo(QrcodeModal);